import { ACADEMY } from "@/config/academy";

export const NAV_LINKS = [
  { label: "Thesis", href: "#thesis", testId: "nav-thesis-link" },
  { label: "Batch Structure", href: "#batches", testId: "nav-batches-link" },
  { label: "FIDE Mentors", href: "#ratings", testId: "nav-mentors-link" },
  { label: "Medalists", href: "#medals", testId: "nav-medalists-link" },
];

export const TopBar = () => {
  return (
    <header className="sticky top-0 z-40 bg-[#faf9f5]/95 backdrop-blur-md border-b border-stone-300" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        <div className="flex items-center space-x-4" data-testid="header-brand">
          <div className="font-mono text-xs font-bold uppercase tracking-widest px-2.5 py-1 bg-emerald-950 text-emerald-100 rounded">
            SQUARE // 64
          </div>
          <span className="font-display text-2xl uppercase tracking-tight text-emerald-950">
            {ACADEMY.name}
          </span>
        </div>

        <nav className="hidden md:flex items-center space-x-8 text-xs font-mono uppercase tracking-wider text-stone-600" data-testid="header-nav">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} data-testid={link.testId} className="hover:text-emerald-950 transition-colors">
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="header-trial-cta"
          className="inline-flex items-center justify-center px-4 py-2 rounded bg-emerald-950 text-emerald-50 text-xs font-mono uppercase tracking-wider hover:bg-emerald-900 transition-colors"
        >
          Claim Trial Slot
        </a>
      </div>
    </header>
  );
};
